export const isNull = <T>(object: T | null): object is null => object === null
